import React, { Component } from 'react'
import {
  Container
} from 'reactstrap'
import { withNamespaces } from "react-i18next"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import Form from './components/Form'

class StoreCreate extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs
              title="Mi tienda"
              breadcrumbItem={`Crear mi tienda`}
              parentLink={`/mi-tienda`}
            />
            <Form />
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

export default withNamespaces()(StoreCreate)
